<template>
    <div>
      
        <div class="imgpost" ><el-image style="width: 100%;" :src="require('../../public/static/homeImg/top1.png')"  fit="fit"></el-image></div>
<!-- 分界线 -->
        <div style="display: flex;justify-content: center;height: 149px;align-items: center;" ref="section1">
          <el-image style="width: 77px; height: 16px" :src="require('../../public/static/homeImg/topleft.png')"  fit="fit"></el-image>
          <div class="title">公司概况</div>
          <el-image style="width:77px; height: 16px" :src="require('../../public/static/homeImg/topright.png')"  fit="fit"></el-image>
        </div>

        <div style="position: relative; height: 500px;">
          <el-image style="width: 70%;height: 500px;position: absolute;left: 0;" :src="require('../../public/static/homeImg/top2.png')"  fit="fit"></el-image>
          <div style="position: absolute;top: 30%;left: 20%;">
            <div class="top2_text">核心价值观</div>
            <div class="top2_text2">
              <p>创新驱动</p>
              <p>客户至上</p>
              <p>合作共赢</p>
            </div>
          </div>
          <el-image style="width: 60%;height: 300px;position: absolute;right: 0;top: 22%;z-index: 2;" :src="require('../../public/static/homeImg/top2_2.png')"  fit="fit"></el-image>
          <div style="position: absolute;top: 35%; right: 16%; width: 40%;z-index: 9; text-align: left;">
            <div> <el-image style="width: 50px;height: 10px;" :src="require('../../public/static/homeImg/top3.png')"  fit="fit"></el-image></div>
            <div class="top3_1">番茄站智能科技有限公司</div>
            <div class="top3_2">总部位于广州，植根粤港澳大湾区。公司以 AI 智能应用为核心，专注于构建平台经济基础设施的高科技企业。 秉持「Fly Beyond · 飞跃无界」的愿景，我们致力于用科技链接人与价值，推动新质生产力的发展与落地。</div>
          </div>
        </div>
        <!-- 分界线 -->
        <div style="display: flex;justify-content: center;height: 149px;align-items: center;" ref="section2">
          <el-image style="width: 77px; height: 16px" :src="require('../../public/static/homeImg/topleft.png')"  fit="fit"></el-image>
          <div class="title">核心优势</div>
          <el-image style="width:77px; height: 16px" :src="require('../../public/static/homeImg/topright.png')"  fit="fit"></el-image>
        </div>

        <div class="top4">
          <el-image style="width:432px; height: 243px;margin-right: 4%;" :src="require('../../public/static/homeImg/top4.png')"  fit="fit"></el-image>
          <div style="width: 60%;text-align: left;">
            <span  style="font-size: 24px;color: #374352;margin-bottom: 15px;">
             <span style="position: relative;">
              <span>核心的技术优势</span> 

              <span  class="redBottom"></span>
             </span>
          
            </span>
            <div style="font-size: 16px;color: #7D858F;text-align: left;line-height: 30px;">技术创新是公司发展的核心驱动力。我们高度重视研发投入，不断引进和培养高素质的技术人才，共同开展前沿技术研究和应用开发。目前，公司已拥有7项发明专利信息，并在人工智能、大数据、云计算等领域取得了显著的技术成果。这些技术成果不仅提升了公司的核心竞争力，更为客户提供了更加高效、智能的解决方案。</div>
          </div>
        </div>

        <div class="top4">
          <div style="width: 60%;text-align: left;">
            <span  style="font-size: 24px;color: #374352;margin-bottom: 15px;">
             <span style="position: relative;">
              <span>专业的团队实力</span> 

              <span  class="redBottom"></span>
             </span>
          
            </span>
            <!-- <div style="font-size: 24px;text-align: left;color: #374352;margin-bottom: 15px;"></div> -->
            <div style="font-size: 16px;color: #7D858F;text-align: left;line-height: 30px;">公司拥有一支由行业资深专家和优秀专业人才组成的团队，他们在各自的领域拥有丰富的经验和深厚的专业知识。团队成员之间密切协作、优势互补，能够为客户提供全方位、一站式的服务。此外，我们还注重员工的培训和发展，定期组织内部培训和外部学习交流活动，不断提升员工的综合能力。</div>
          </div>
          <el-image style="width:432px; height: 243px;margin-left: 4%;" :src="require('../../public/static/homeImg/top5.png')"  fit="fit"></el-image>

        </div>
        <div class="top4">
          <el-image style="width:432px; height: 243px;margin-right: 4%;" :src="require('../../public/static/homeImg/top6.png')"  fit="fit"></el-image>
          <div style="width: 60%;text-align: left;">
            <span  style="font-size: 24px;color: #374352;margin-bottom: 15px;">
             <span style="position: relative;">
              <span>优质的客户资源</span> 

              <span  class="redBottom"></span>
             </span>
          
            </span>
            
            <!-- <div style="font-size: 24px;text-align: left;color: #374352;margin-bottom: 15px;">优质的客户资源</div> -->
            <div style="font-size: 16px;color: #7D858F;text-align: left;line-height: 30px;">凭借卓越的服务品质和良好的口碑，番茄站已经与众多知名企业建立了长期稳定的合作关系，涵盖了互联网、通信、科技、金融、房地产、教育等多个行业。这些优质客户不仅为我们带来了稳定的业务收入，更为我们提供了丰富的项目经验和行业资源，助力我们在业务承接领域不断取得新的突破。</div>
          </div>
        </div>

        <div class="top4">
          <div style="width: 60%;text-align: left;">
            <span  style="font-size: 24px;color: #374352;margin-bottom: 15px;">
             <span style="position: relative;">
              <span>优质的服务体验</span> 

              <span  class="redBottom"></span>
             </span>
          
            </span>
            <!-- <div style="font-size: 24px;text-align: left;color: #374352;margin-bottom: 15px;">优质的服务体验</div> -->
            <div style="font-size: 16px;color: #7D858F;text-align: left;line-height: 30px;">我们深知，优质的服务是赢得客户信任和满意的关键。因此，公司始终将客户需求放在首位，通过建立完善的客户服务体系，为客户提供全方位、一站式的服务。从项目咨询、方案设计到项目实施、后期维护，我们都将为客户提供专业、细致、周到的服务，确保客户的需求得到充分满足。</div>
          </div>
          <el-image style="width:432px; height: 243px;margin-left: 4%;" :src="require('../../public/static/homeImg/top7.png')"  fit="fit"></el-image>

        </div>
        <!-- 分界线--行业影响力 -->
        <div style="display: flex;justify-content: center;height: 149px;align-items: center;" ref="section3">
          <el-image style="width: 77px; height: 16px" :src="require('../../public/static/homeImg/topleft.png')"  fit="fit"></el-image>
          <div class="title">行业影响力</div>
          <el-image style="width:77px; height: 16px" :src="require('../../public/static/homeImg/topright.png')"  fit="fit"></el-image>
        </div>

        <div style="height: 382px;position: relative;" >
          <el-image style="width: 100%; height: 382px" :src="require('../../public/static/homeImg/top8.png')"  fit="fit"></el-image>
          <div style="position: absolute; top: 100px;left: 10%;width: 45%;text-align: left;">
            <div style="font-size: 28px;color: #374352;margin-bottom: 20px;">数字经济新业态先行企业</div>
            <div style="font-size: 16px;color: #374352;line-height: 30px;">番茄站智能科技有限公司在行业内具有较高的知名度和影响力，我们积极参与行业标准的制定和技术规范的推广，为行业的健康有序发展贡献自己的智慧和力量。同时，我们还多次参与行业高峰论坛、技术研讨会等活动，与同行分享经验、交流技术，推动行业整体技术水平的提升和创新发展。</div>
          </div>
          <div></div>
        </div>

                <!-- 分界线--获得荣誉 -->
                <div style="display: flex;justify-content: center;height: 149px;align-items: center;" ref="section4">
          <el-image style="width: 77px; height: 16px" :src="require('../../public/static/homeImg/topleft.png')"  fit="fit"></el-image>
          <div class="title">获得荣誉</div>
          <el-image style="width:77px; height: 16px" :src="require('../../public/static/homeImg/topright.png')"  fit="fit"></el-image>
        </div>


        <div style="width: 80%;margin: 0 auto;"> 
           <el-carousel :interval="4000" type="card" height="400px">
    <el-carousel-item v-for="item in imgs" :key="item.url">
      <el-image :src="item.url"  fit="fit" style="height: 80%;margin-top: 5%;"></el-image>
      <div class="carousel-title">{{ item.name }}</div>
    </el-carousel-item>
  </el-carousel></div>

  <div style="background: #F4F8FB;" ref="section5">
                <!-- 分界线--获得荣誉 -->
                <div style="display: flex;justify-content: center;height: 149px;align-items: center;">
          <el-image style="width: 77px; height: 16px" :src="require('../../public/static/homeImg/topleft.png')"  fit="fit"></el-image>
          <div class="title">未来展望</div>
          <el-image style="width:77px; height: 16px" :src="require('../../public/static/homeImg/topright.png')"  fit="fit"></el-image>
        </div>

        <div style="display: flex;width: 82%;margin: 0 auto;justify-content: space-between;    padding-bottom: 50px;">
          <div class="boxSpan">
            <div style="position: relative;">
              <el-image style="width: 100%; height: 120px" :src="require('../../public/static/homeImg/top9_1.png')"  fit="fit"></el-image>
<div class="centerTitle">发展理念</div>
            </div>
          <div class="padTop">
            <div class="centerSpan"><span class="redLi"></span><span class="padLeft">坚守初心，持续创新</span></div>
            <div class="centerSpan"><span class="redLi"></span><span class="padLeft">以技术、品质、服务为三大支柱</span></div>

          </div>

          </div>
          <div class="boxSpan">
            <div style="position: relative;">
            
          <el-image style="width: 100%; height: 120px" :src="require('../../public/static/homeImg/top10.png')"  fit="fit"></el-image>
<div class="centerTitle">核心战略</div>

          </div>
          <div class="padTop">
            <div class="centerSpan"><span class="redLi"></span><span class="padLeft">加大研发投入，提升技术实力</span></div>
            <div class="centerSpan"><span class="redLi"></span><span class="padLeft">优化服务流程，提高服务质量</span></div>
            <div class="centerSpan"><span class="redLi"></span><span class="padLeft">满足客户需求，建立相互信任</span></div>


          </div>

          </div>
          <div class="boxSpan">
            <div style="position: relative;">

          <el-image style="width: 100%; height: 120px" :src="require('../../public/static/homeImg/top11.png')"  fit="fit"></el-image>
<div class="centerTitle">拓展计划</div>

          </div>
          <div class="padTop">
            <div class="centerSpan"><span class="redLi"></span><span class="padLeft">开拓新业务领域</span></div>
            <div class="centerSpan"><span class="redLi"></span><span class="padLeft">加强企业合作交流</span></div>
            <div class="centerSpan"><span class="redLi"></span><span class="padLeft">探索创新商业模式</span></div>


          </div>

          </div>
          <div class="boxSpan">
            <div style="position: relative;">

          <el-image style="width: 100%; height: 120px" :src="require('../../public/static/homeImg/top12.png')"  fit="fit"></el-image>
<div class="centerTitle">发展愿景</div>

          </div>
          <div class="padTop">
            <div class="centerSpan"><span class="redLi"></span><span class="padLeft">成为科技服务领域领先企业</span></div>
            <div class="centerSpan"><span class="redLi"></span><span class="padLeft">助力中国数字经济发展</span></div>
            <div class="centerSpan"><span class="redLi"></span><span class="padLeft">通过团队协作创造更大成就</span></div>


          </div>

          </div>
        </div>
      </div>
      <!-- <div>
        <div><el-image style="width: 100%;height: 300px;" :src="require('../../public/static/homeImg/footer.png')"  fit="fit"></el-image></div>
  </div> -->

  </div>
  </template>
  <script>
import { EventBus } from '../components/eventBus'

    export default {
      name: 'PageOne',// 使用多词名称
  
      data() {
        return {
          activeName: 'second',
          imgs:[
            {url:require('../../public/static/img/zhengshu1.png'),name:'EDI证书'},
            {url:require('../../public/static/img/zhengshu2.png'),name:'ISO证书'},
            {url:require('../../public/static/img/zhengshu3.png'),name:'安全等保证书'},
            {url:require('../../public/static/img/zhengshu4.png'),name:'高新企业证书'},
            {url:require('../../public/static/img/zhengshu5.png'),name:'科技型中小企业证书'},
            {url:require('../../public/static/img/zhengshu6.png'),name:'软著证书'},




          ]
        };
      },
      created() {

    EventBus.$on('scrollTop', this.scrollPage);
  },
  beforeDestroy() {
    EventBus.$on('scrollTop', this.scrollPage);

  },
      methods: {
        scrollPage(refName){
        console.log(refName,"传过来了锚点222");
        this.$nextTick(() => {
        const el = this.$refs[refName.index]
        if(el){
        el.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'  // 对齐到视口顶部
        })
      }
      })

      },
        handleClick(tab, event) {
          console.log(tab, event);
          if(tab.index==0){
            // 路径跳转
this.$router.push('../view/PageOne.vue')
          }
        }
      }
    };
  </script>
  <style scoped>
.centerTitle{
  position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 20px;
}

  .carousel-title {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  color: rgb(22, 21, 21);
  font-size: 16px;
  /* background: rgba(0,0,0,0.5); */
  padding: 5px 15px;
  border-radius: 4px;
}
.top2_text{
  font-family: PingFang SC, PingFang SC;
font-weight: bold;
font-size: 28px;
color: #FFFFFF;
padding: 10px 0;
padding-left: 20px;
border-left: 3px solid #FFFFFF;
background-color: #F7A6A4;
}
.top2_text2{
font-family: PingFang SC, PingFang SC;
font-size: 22px;
color: #FFFFFF;
border-left: 1px solid #FFFFFF;;
margin-left: 0.5px;
}
.top2_text2 p{
  padding-top: 10px;
}
.top3_1{
  font-size: 20px;
color: #374352;
margin: 12px 0;
}
.top3_2{
  font-size: 16px;
  color: #374352;
  line-height: 30px;
}
.top4{
  width: 82%;
  margin: 0 auto;
  display: flex;
  padding-bottom: 48px;
  border-bottom: 2px solid #E1E6EA;
  margin-bottom: 48px;
}
.el-carousel__item h3 {
    color: #475669;
    font-size: 16px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #F4F8FB;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color:#CAD1D7
  }
  .title{
    font-weight: bold;
font-size: 30px;
color: #374352;
  }
  .redLi{
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    /* border: 1px solid #FF2C27; */
    background-color: #FF2C27;
    /* box-shadow: 0 0 1px 2px rgb(222 72 72 / 60%); */

  }
  .boxSpan{
    font-size: 16px;
    display: flex;
    flex-direction: column;
    width: 23%;
  }
  .centerSpan{
    font-size: 16px;
display: flex;
align-items: center;
  }
  .padTop{
    padding-left: 20px;
    padding-top: 25px;
    height: 120px;
    background-color: #fff;
  }
  .centerSpan{
    margin-top: 10px;
  }
  .padLeft{
    margin-left: 10px;
  }
  .redBottom{
    position: absolute;
    height: 8px;
    width: 100%;
    left: 0;
    bottom: 3px;
    border-bottom: 8px solid rgb(252, 210, 210);
    /* opacity: .4; */
    z-index: -1;
  }
  </style>